// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carrier-message-bar {
  display: grid;
  background: #ffffff;
  border: 1.5px solid #1a6a7c;
  border-radius: 1.5vw;
  text-align: center;
  padding: 0.1vw;
  margin: 0.1vw;
  color: #1a6a7c;
  font-size: 1.2vw;
}
.carrier-top-bar-button {
  display: grid;
  grid-template-columns: 74vw auto;
  gap: 2.5vw;
  align-items: end;
}
.carrier-top-bar {
  display: grid;
  grid-template-columns: 12.2vw auto 2.5vw;
  height: min-content;
  gap: 0.5vw;
}

.carrier-button-setting {
  display: grid;
  place-items: center;
  width: 12.2vw;
  grid-template-columns: repeat(4, max-content);
  gap: 0.5vw;
}

.carrier-icon {
  display: grid;
  height: 2.2vw;
}
.carrier-icon:active {
  filter: brightness(0.8);
}

.carrier-icons {
  display: grid;
  height: 2.5vw;
  width: 100%;
}
.carrier-nextButton {
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  height: 5vw;
}

.next {
  height: 2.3vw;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
}
.carrier-stopButton {
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  height: 5vw;
}
.stop {
  height: 2.3vw;
  
}

.carrier-auxButtons {
  display: grid;
  height: 5.4vw;
  grid-template-rows: repeat(2, 2.2vw);
  row-gap: 0.7vw;
  justify-self: center;
  column-gap: 1vw;
}
.carrier-transButtons {
  display: grid;
  column-gap: 1vw;
  justify-self: center;
  grid-template-columns: repeat(2, 3.5vw);
}
.carrier-persButtons-family {
  display: grid;
  justify-self: center;
  grid-template-columns: repeat(4, 3.5vw);
}
.carrier-persButtons-animal {
  display: grid;
  justify-self: center;
  grid-template-columns: repeat(3, 3.5vw);
}
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/Carrier/styles/CarTopBar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gCAAgC;EAChC,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,wCAAwC;EACxC,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,6CAA6C;EAC7C,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,aAAa;AACf;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,WAAW;AACb;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,aAAa;EACb,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,aAAa;;AAEf;;AAEA;EACE,aAAa;EACb,aAAa;EACb,oCAAoC;EACpC,cAAc;EACd,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,uCAAuC;AACzC","sourcesContent":[".carrier-message-bar {\n  display: grid;\n  background: #ffffff;\n  border: 1.5px solid #1a6a7c;\n  border-radius: 1.5vw;\n  text-align: center;\n  padding: 0.1vw;\n  margin: 0.1vw;\n  color: #1a6a7c;\n  font-size: 1.2vw;\n}\n.carrier-top-bar-button {\n  display: grid;\n  grid-template-columns: 74vw auto;\n  gap: 2.5vw;\n  align-items: end;\n}\n.carrier-top-bar {\n  display: grid;\n  grid-template-columns: 12.2vw auto 2.5vw;\n  height: min-content;\n  gap: 0.5vw;\n}\n\n.carrier-button-setting {\n  display: grid;\n  place-items: center;\n  width: 12.2vw;\n  grid-template-columns: repeat(4, max-content);\n  gap: 0.5vw;\n}\n\n.carrier-icon {\n  display: grid;\n  height: 2.2vw;\n}\n.carrier-icon:active {\n  filter: brightness(0.8);\n}\n\n.carrier-icons {\n  display: grid;\n  height: 2.5vw;\n  width: 100%;\n}\n.carrier-nextButton {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-end;\n  height: 5vw;\n}\n\n.next {\n  height: 2.3vw;\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-end;\n}\n.carrier-stopButton {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-end;\n  height: 5vw;\n}\n.stop {\n  height: 2.3vw;\n  \n}\n\n.carrier-auxButtons {\n  display: grid;\n  height: 5.4vw;\n  grid-template-rows: repeat(2, 2.2vw);\n  row-gap: 0.7vw;\n  justify-self: center;\n  column-gap: 1vw;\n}\n.carrier-transButtons {\n  display: grid;\n  column-gap: 1vw;\n  justify-self: center;\n  grid-template-columns: repeat(2, 3.5vw);\n}\n.carrier-persButtons-family {\n  display: grid;\n  justify-self: center;\n  grid-template-columns: repeat(4, 3.5vw);\n}\n.carrier-persButtons-animal {\n  display: grid;\n  justify-self: center;\n  grid-template-columns: repeat(3, 3.5vw);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
